var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { Types } from '../../../../states/actions';
import { parseTwilioMessage } from '../../../../utils';
import { postBotMessage, Triggers } from '../../../../../apis/postBotMessage';
var PAGE_SIZE = 20;
var messagePaginator; // Twilio SDK Messages Instance
/**
 * `useMessages` hook can be used to retrieve and update data related to Twilio Channel Messages.
 *
 * @param chatState
 * @param dispatch
 * @param sessionToken
 * @param apiBaseUrl
 */
export function useMessages(chatState, dispatch, sessionToken, apiBaseUrl, userType) {
    var _this = this;
    var channel = chatState.channel, messages = chatState.messages, members = chatState.members, hasMore = chatState.hasMore, fetchingMore = chatState.fetchingMore;
    // Whenever channel is update, we wish to retrieve all messages, and handle other events (should fire once only)
    useEffect(function () {
        if (channel) {
            var getPreviousMessages = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    dispatch({
                        type: Types.UPDATE_FETCH_MORE_STATUS,
                        payload: true,
                    });
                    return [2 /*return*/];
                });
            }); };
            dispatch({
                type: Types.UPDATE_FETCH_MORE_METHOD,
                payload: getPreviousMessages,
            });
            var fetchMessages = function () { return __awaiter(_this, void 0, void 0, function () {
                var err_1, lendiMessages, successful, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dispatch({
                                type: Types.LOADING,
                                payload: true,
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, channel.getMessages(PAGE_SIZE)];
                        case 2:
                            messagePaginator = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            throw new Error("@lendi/chat: unable to get Twilio messages: ".concat(err_1));
                        case 4:
                            dispatch({
                                type: Types.LOADING,
                                payload: false,
                            });
                            // Update hasPrevPage
                            dispatch({
                                type: Types.UPDATE_HAS_MORE,
                                payload: !!(messagePaginator === null || messagePaginator === void 0 ? void 0 : messagePaginator.hasPrevPage),
                            });
                            lendiMessages = messagePaginator === null || messagePaginator === void 0 ? void 0 : messagePaginator.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types.UPDATE_MESSAGES,
                                payload: lendiMessages || [],
                            });
                            if (!(userType === 'customer' && (lendiMessages === null || lendiMessages === void 0 ? void 0 : lendiMessages.length) === 0)) return [3 /*break*/, 9];
                            dispatch({ type: Types.START_BOT_TYPING });
                            _a.label = 5;
                        case 5:
                            _a.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, postBotMessage(channel.uniqueName, sessionToken, apiBaseUrl, Triggers.NoChatHistory)];
                        case 6:
                            successful = _a.sent();
                            if (!successful) {
                                throw new Error("useSendBotMessage could not send the message with: ".concat(Triggers.NoChatHistory));
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            error_1 = _a.sent();
                            throw new Error("@lendi/chat: ".concat(error_1.message, " with: ").concat(Triggers.CustomerAwaitingTeamMemberResponse));
                        case 8:
                            dispatch({ type: Types.STOP_BOT_TYPING });
                            _a.label = 9;
                        case 9: return [2 /*return*/];
                    }
                });
            }); };
            fetchMessages();
            channel.on('messageAdded', function (newMessage) {
                dispatch({
                    type: Types.NEW_MESSAGE,
                    payload: parseTwilioMessage(newMessage, members),
                });
            });
        }
        else {
            // Channel was removed, clear data
            dispatch({
                type: Types.UPDATE_HAS_MORE,
                payload: false,
            });
            dispatch({
                type: Types.UPDATE_MESSAGES,
                payload: [],
            });
            dispatch({
                type: Types.UDPATE_HAS_NEW,
                payload: false,
            });
        }
    }, [channel === null || channel === void 0 ? void 0 : channel.sid]);
    // Whenever messages is update, we wish to update the markRead method
    useEffect(function () {
        var setMessagesRead = function () { return __awaiter(_this, void 0, void 0, function () {
            var lastMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: Types.UDPATE_HAS_NEW,
                            payload: false,
                        });
                        lastMessage = messages.length > 0 && messages[messages.length - 1];
                        if (!lastMessage) return [3 /*break*/, 2];
                        return [4 /*yield*/, channel.updateLastConsumedMessageIndex(lastMessage.index)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        dispatch({
            type: Types.UPDATE_MARK_READ_METHOD,
            payload: setMessagesRead,
        });
    }, [messages]);
    useEffect(function () {
        if (fetchingMore) {
            var fetchMoreMessagesAsync = function () { return __awaiter(_this, void 0, void 0, function () {
                var moreMessages, lendiMessages;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(hasMore && messagePaginator)) return [3 /*break*/, 2];
                            return [4 /*yield*/, messagePaginator.prevPage()];
                        case 1:
                            moreMessages = _a.sent();
                            dispatch({
                                type: Types.UPDATE_HAS_MORE,
                                payload: moreMessages.hasPrevPage,
                            });
                            messagePaginator = moreMessages;
                            lendiMessages = moreMessages.items.map(function (message) { return parseTwilioMessage(message, members); });
                            dispatch({
                                type: Types.UPDATE_FETCH_MORE_MESSAGES,
                                payload: lendiMessages,
                            });
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); };
            fetchMoreMessagesAsync();
        }
        else {
            // DO nothing
        }
    }, [fetchingMore]);
}
//# sourceMappingURL=index.js.map